<div class="d-flex justify-content-between align-items-center w-100">
  <div class="d-flex justify-content-start align-items-center w-100">
    <!--    <sb-action-required [booking-status]="campaignOverview?.campaign?.booking-status"></sb-action-required>-->
    <div>
      <h5 [innerHTML]="campaignOverview?.campaign.name | truncate : 30"></h5>
      <div class="d-flex">
        <div>
					<span><sb-icon icon="level"></sb-icon>
            {{campaignOverview?.campaign?.level?.id.level}} "{{campaignOverview?.campaign?.level?.name}}"
						<span class="mx-1">|</span>

      </span>
        </div>
        <div>
          <sb-icon icon="company"></sb-icon>
          {{campaignOverview?.campaign?.customer?.name}}

        </div>

      </div>
    </div>
  </div>
  <div class="d-flex align-items-center">
    <sb-comp-filter-overview [bookingEditorView]="true"
                             [geoCull]="campaignOverview.campaign.geoCull"
                             [playerCull]="campaignOverview.campaign.playerCull" [showCaption]="false"
                             [timeCull]="campaignOverview.campaign.timeCull"
                             class="mr-2"></sb-comp-filter-overview>
    <sb-cull-preview [playerAggregationData]="campaignOverview.campaign.playerAggregation"></sb-cull-preview>

  </div>
</div>
